import {wupoServerUri} from "../Api";


function fetchDevicesUsers(FPVerification){
    console.log(FPVerification) //DEBUG
    console.log(wupoServerUri.devnet) //DEBUG
    return(
        fetch(`${wupoServerUri.devnet}/api/auth/autocompleteLogin`, {
            method: "POST",
            body: JSON.stringify(FPVerification),
            credentials: 'include',
            headers: {
              "Content-Type": "application/json",
            },
        })
        .then((response) => {
            console.log(response.status);
            if(response.status === 200){
                return response.json();
            }
            else{
                return "Not found";
            }
        })
        .then((userLogin) => {
            // console.log(userLogin); // DEBUG PRINTING
            
            return userLogin;
        })
        .catch((error) => {
            console.log("Error: " + error);
        })
    )
}


function phoneValidation(verificationObj, jwtToken){
    console.log(verificationObj) //LOANS DEBUG PRINTING

    return(
        fetch(`${wupoServerUri.devnet}/api/secure/phoneverify`, {
            method: "POST",
            body: JSON.stringify(verificationObj),
            credentials: 'include',
            headers: {
              "Authorization": `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
        })
        .then((response) => {
            console.log(response.status);
            return response.json();
            // if(response.status === 200){
            //     return response.json();
            // }
            // else{
            //     return "Not found";
            // }
        })
        .then((verification) => {
            console.log(verification); // //LOANS DEBUG PRINTING
            
            return verification;
        })
        .catch((error) => {
            console.log("Error: " + error);
        })
    )
}

function phoneCode(visitorphone, jwtToken){
    console.log(visitorphone) //LOANS DEBUG PRINTING

    return(
        fetch(`${wupoServerUri.devnet}/api/secure/phonecode`, {
            method: "POST",
            body: JSON.stringify(visitorphone),
            credentials: 'include',
            headers: {
              "Authorization": `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
        })
        .then((response) => {
            console.log(response.status);
            return response.json();
            // if(response.status === 200){
            //     return response.json();
            // }
            // else{
            //     return "Not found";
            // }
        })
        .then((verification) => {
            console.log(verification); // //LOANS DEBUG PRINTING
            
            return verification;
        })
        .catch((error) => {
            console.log("Error: " + error);
        })
    )
}


const fetchSingleClientsInformation = (clientAccount, jwtToken) => {
    console.log(clientAccount);
    const clietnRequest={
        username: clientAccount,
    }
    return(
      fetch(`${wupoServerUri.devnet}/api/auth/getclientprofile`, {
          
          method: 'POST',
          body: JSON.stringify(clietnRequest),
          headers: {
            'Authorization': `Bearer ${jwtToken}`, 
            'Content-Type': 'application/json'                     
          }
          
        }).then((response) => { 
          // console.log(response.status) // DEBUG PRINTING
  
          if(response.status === 200){
            console.log(response.status);
            return response.json();
          }
          else{
              return "Error";
          }
        
        }).then((clientInfo) => {
            console.log(clientInfo)  ; 
            return(clientInfo);
            
      }).catch(function(error){
          console.log("Error msg: "+ error);
      })
    );
  
  };

export{fetchSingleClientsInformation, fetchDevicesUsers, phoneValidation, phoneCode}